/**
 * Generates a URL-safe hash from a display name
 * @param {string} displayName - The display name to convert
 * @returns {string} URL-safe hash fragment
 */
export function generateMenuItemHash(displayName) {
  return `#${displayName.toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')}`;
}

/**
 * Generates a URL-safe hash from a category display name
 * @param {string} displayName - The display name of the category
 * @returns {string} URL-safe hash fragment
 */
export function generateCategoryHash(displayName) {
  return `#${displayName.toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')}`;
}

/**
 * Updates the browser's hash without using Vue Router
 * @param {string} hash - The hash to set (should include #)
 */
export function setBrowserHash(hash) {
  if (hash && hash.startsWith('#')) {
    window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}${hash}`);
  }
}

/**
 * Helper function to add hash to router payload when selectedItem is available
 * @param {Object} routerPayload - The router payload object
 * @param {Object} selectedItem - The selected menu item from store
 * @returns {Object} - The updated router payload
 */
export function addMenuItemHashToRoute(routerPayload, selectedItem) {
  if (selectedItem && selectedItem.displayName
      && (routerPayload.name === 'orderAheadMenuItemDetailsPage' || routerPayload.name === 'orderAtTableMenuItemDetailsPage')) {
    routerPayload.hash = generateMenuItemHash(selectedItem.displayName);
  }
  return routerPayload;
}
